import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map as rxjsMap} from "rxjs/operators";
import {sortObjectsByProperty} from "../lib/utils";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ComponentPrintoutService {
    private _http: HttpClient = inject(HttpClient)
    private baseEndpoint: string = "/api/component_printout"

    getPrintouts(componentId: string, printoutIds?: string[]): Observable<any[]> {
        return this._http.get<any>(`${this.baseEndpoint}/${componentId}`).pipe(
            rxjsMap(response => response.data),
            rxjsMap(printouts => {
                if (printoutIds) {
                    printouts = printouts.filter(p => printoutIds.includes(String(p.id)));
                }
                if (!printouts.length) return [{name: 'No printouts available', url: ''}];
                sortObjectsByProperty(printouts, 'column_order', null, true);
                const getContext = ((format: 'pdf' | 'docx' | 'xlsx') => {
                    let params = {context: JSON.stringify({component_id: componentId, format: format})};
                    return new URLSearchParams(params).toString()
                })
                return printouts.map(printout => ({
                        name: printout.attributes.name,
                        additional_formats: printout.attributes.additional_formats || [],
                        url: '/api/generate_printout/' + printout.id + '?' + getContext('pdf'),
                        url_word: '/api/generate_printout/' + printout.id + '?' + getContext('docx'),
                        url_excel: '/api/generate_printout/' + printout.id + '?' + getContext('xlsx'),
                    }));
            })
        );
    }
}
